// extracted by mini-css-extract-plugin
module.exports = {"block":"index_block_3jnFT","inner":"index_inner_1wpPF","form":"index_form_1dixL"};